import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { AbstractRealityCheckDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractRealityCheckDialogProperties";
import { AbstractRealityCheckNoOptionsDialogProperties } from "@lib/titan2/dist/game/view/properties/AbstractRealityCheckNoOptionsDialogProperties";
import * as PIXI from "pixi.js";
export class RealityCheckDialogProperties extends AbstractRealityCheckDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        const imageWidth = 836;
        this.titleFieldProperties.position.set(imageWidth / 2, 120);
        this.titleFieldProperties.size = new PIXI.Point(760, 200);
        this.messageFieldProperties.position.set(imageWidth / 2, 60);
        this.messageFieldProperties.size = new PIXI.Point(760, 240);
        this.messageFieldProperties.verticalAlign = ControlConstants.CENTER;
        this.winFieldProperties.position.set(imageWidth / 2, 324);
        this.winFieldProperties.size = new PIXI.Point(760, 70);
        this.wageredFieldProperties.position.set(imageWidth / 2, 410);
        this.wageredFieldProperties.size = new PIXI.Point(760, 70);
        const buttonImageWidth = 608;
        const buttonX = imageWidth / 2 - buttonImageWidth / 2;
        this.exitGameButtonProperties.position.set(buttonX, 528);
        this.exitGameButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
        this.wagerHistoryButtonProperties.position.set(buttonX, 638);
        this.wagerHistoryButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
        this.continueButtonProperties.position.set(buttonX, 750);
        this.continueButtonProperties.textFieldProperties.size = new PIXI.Point(600, 100);
    }
}
/**
 * RealityCheckNoOptionsDialogProperties.ts
 */
export class RealityCheckNoOptionsDialogProperties extends AbstractRealityCheckNoOptionsDialogProperties {
    setDefaultValues() {
        super.setDefaultValues();
        const imageWidth = 836;
        const buttonImageWidth = 608;
        const buttonX = imageWidth / 2 - buttonImageWidth / 2;
        this.titleFieldProperties.position = new PIXI.Point(imageWidth / 2, 60);
        this.titleFieldProperties.size = new PIXI.Point(800, 160);
        this.timeFieldProperties.position = new PIXI.Point(imageWidth / 2, 250);
        this.timeFieldProperties.size = new PIXI.Point(800, 160);
        this.messageFieldProperties.position = new PIXI.Point(imageWidth / 2, 400);
        this.messageFieldProperties.size = new PIXI.Point(800, 240);
        this.confirmButtonProperties.position = new PIXI.Point(buttonX, 700);
        this.confirmButtonProperties.textFieldProperties.size = new PIXI.Point(550, 75);
    }
}
//# sourceMappingURL=RealityCheckDialogProperties.js.map